// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4d-2";
export var cell = "_4d-6";
export var cellContainer = "_4d-3";
export var disabled = "_4d-5";
export var featuredIconCellContainer = "_4d-7";
export var featuredIconTextContainer = "_4d-9";
export var featuredIconWrapper = "_4d-8";
export var hasRowsSelected = "_90-1";
export var noBorder = "_4d-a";
export var overflowableText = "_4d-0";
export var overflowableTextContainer = "_4d-1";
export var row = "_4e-0";
export var rowCheckboxCell = "_4d-4";
export var selectableTable = "_90-2";